define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/config",
	"csi/table/New",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"./BOM/BOMSectionMixin",
	"./BOM/PartMaterialBOMSectionMixin",
	"./SpecialMaterial"

], function (declare, _, config, New, ActionControllerMixin, xml, Query, BOMSectionMixin, PartMaterialBOMSectionMixin) {

	return declare([New, ActionControllerMixin, BOMSectionMixin, PartMaterialBOMSectionMixin], {

		FIELD_CREATE_ASSEMBLY: "CreateAssembly",

		PATH_SIZE_RANGE: xml.path(xml.ATTR_PARENT, xml.ATTR_PARENT, "Attributes", "ActualSizeRange"),

		urlPartMaterial: null,

		isCreateAssemblyAvailable: true,

		skipWizardTitles: false,

		onDependencyPaths: function (paths) {
			// summary: size range is needed to determine if style has 2D sizes
			paths.push(this.PATH_SIZE_RANGE);
			this.inherited(arguments);
		},

		onStart: function () {
			this.wizardSkipPages = [];

			const BOM = this.m_cache.getNode(this.getParent().__Parent__);
			const product = this.m_cache.getNode(BOM.__Parent__);
			if (!product || product.$Type === "Material" || product.$Type === "ProductSource" || product.IsTemplate || this._isTwoDim(product) || !this._hasMaterialBOMSubtypes(BOM) || BOM.IsSampleBOM) {
				this.isCreateAssemblyAvailable = false;
				this.wizardSkipPages.push(1);
				this.skipWizardTitles = true;
			}
		},

		_isTwoDim: function (/*Object*/product) {
			// summary: Styles with a size range that is 2 dimensional should not use the kit wizard

			const attributes = this.m_cache.getNode(product.Attributes);
			const sizeRange = this.m_cache.getNode(attributes.ActualSizeRange);

			return sizeRange && sizeRange.IsTwoDim;
		},

		_hasMaterialBOMSubtypes: function (apparelBOM) {
			// This query will search client cached SubType Settings that are Active.
			const exposeBOMSupplierAttributes = config.getNodeSetting(apparelBOM, "ExposeBOMSupplierAttributes");
			const store = config.getSubtypeStore("MaterialBOM");

			const nResults = store && store.query({Active: true}).length;
			if (!nResults) {
				return false;
			}

			// C8-6780 Since ExposeBOMSupplierAttributes only shows when its set to true
			// When the input subtype is false the logic has to compare total vs total subtypes with Expose = true
			const nExposed = store.query({ExposeBOMSupplierAttributes: true}).length;
			if (exposeBOMSupplierAttributes) {
				return nExposed > 0;
			}

			return nResults > nExposed;
		},

		_isCreateAssemblyEnabled: function (/*Content*/page) {
			return this.isCreateAssemblyAvailable
				&& page.getView().defView.getFieldValue(this.FIELD_CREATE_ASSEMBLY);
		},

		_hasSelections: function () {
			const fd = this.m_formData;
			if (fd) {
				return fd.hasSelections();
			}

			return true;
		},

		disableNext: function (/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*Number*/index) {
			// enable Next when FIELD_CREATE_ASSEMBLY is true
			return !this._isCreateAssemblyEnabled(page);
		},

		disableFinish: function (/*csi.wizard.Widget*/wizard, /*Content*/page, /*Number*/index) {
			// enable Finish when FIELD_CREATE_ASSEMBLY is false or the table has selected values
			return ((index === 0 && this._isCreateAssemblyEnabled(page)) ||
				(index === 1 && !this._hasSelections()));
		},

		getNewNodes: function () {
			// summary: return PartMaterial as a new node
			const node = this.m_cache.getNode(this.urlPartMaterial);
			return node ? [node] : null;
		},

		toWriterRequest: function (/*FormData?*/fd) {
			// summary: add PartMaterial url to request
			const call = this.inherited(arguments);
			this.urlPartMaterial = this.createNewUrl();
			call.addParameter("PartMaterialURL", xml.ATTR_REF, this.urlPartMaterial);
			return call;
		},

		getReturnNodeRequest: function (/*String[]*/urlsNew) {
			// summary: add PartMaterial url to request
			urlsNew.push(this.urlPartMaterial);
			return this.inherited(arguments);
		},

		getWizardViewQuery: function (/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: add query filters to the views in wizard
			let q = this.inherited(arguments);

			// Restrict placements that are in the same BOMSection when selecting PartMaterials for an assembly
			if (index === 1 && this._groupResults) {
				q = new Query();

				this._groupResults.every(function (result, index) {
					const gs = result.level.groupSpec
					const groupId = gs.heading.m_id;

					if (groupId === "DSSection") {
						q.RefAttr(groupId, xml.OP_EQUALS, result.groupValue);
						return false;
					}

					return true;
				}, this);
			}

			return q;
		},

		/**
		 * @override
		 * Fix ProductType if action invoked within group by type
		 */
		onWizardViewCreate: function (wizard, page, view) {
			if (wizard.getIndexOfPage(page) === 0) {
				const productTypeUrl = this.widget.getActionElementGroupProductType(this);
				if (productTypeUrl) {
					view.addFixedValue("ProductType", productTypeUrl);
				}
			}
		},

		onWizardViewPreCreate: function (/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*csi.view.Widget*/view, viewParams) {
			if (wizard.getIndexOfPage(page) !== 0)
				return;

			const popupView = this.popupView;
			const bomSectionQuery = new Query()
			if (this._groupResults) {
				_.each(this._groupResults, function (gr) {
					this.applyBomSectionQuery(gr.groupValue, bomSectionQuery, this.m_cache, true);
				}, this);
			}

			// the Subtype and SubtypeSettings nodes are added to cache in _preActionRequests function
			const apparelBOM = this.m_cache.getNode(this.getParent().__Parent__);
			const exposeBOMSupplierAttributes = config.getNodeSetting(apparelBOM, "ExposeBOMSupplierAttributes");

			viewParams.bomSectionQuery = bomSectionQuery;
			viewParams.isCreateAssemblyAvailable = this.isCreateAssemblyAvailable;
			viewParams.exposeBOMSupplierAttributes = exposeBOMSupplierAttributes;
			viewParams.onChangeAssembly = function () {
				popupView.set("disabled", false);
			};
		},

		postProcessSuccess: function () {
			const fd = this.m_formData;
			const partMaterialUrls = fd.getSelectedValue();
			const view = this.widget;

			// if there's no group at all or creating assembly on it, refresh the data
			if (partMaterialUrls.length > 0 || !this._groupResults) {
				return view.refreshData();
			}

			return this.inherited(arguments);
		},

		_newPostProcessRefNode: function (refNode) {
			this.widget.expandRow(refNode);
		},

		/**
		 * disable Finish & Go
		 */
		_canNavigate: function () {
			return false;
		},
	});
});
